export default __webpack_public_path__ + "static/media/tos.22108621.txt";